import { Modal, Form, Select } from 'antd';
import { authFetch } from '../../../../../common/request/authFetch';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';

export const EditProjectEmailsModal = (props : {projectReportConfig: any, onFinish: any}) => {
    
    const [form] = Form.useForm();
    
    const onFormFinish = async (values: any) => {
        const data = {
            ...values
        };
        await authFetch(`${process.env.REACT_APP_API}/projects/${props.projectReportConfig.project}/reports/emails`, { method: 'PUT', data: data });        
        props.onFinish();
    };

  return (
    <>
        <Modal 
            open={true} 
            okText='Guardar'
            cancelText='Cancelar'
            onOk={() => form.submit()} 
            onCancel={props.onFinish} 
            afterClose={form.resetFields}
            destroyOnClose
            {...modalPanelStyles}
            title={<DrawerPanelTitle title="Gestionar destinatarios" />}
        >
            <Form 
                layout='vertical' 
                form={form} 
                onFinish={onFormFinish}
                autoComplete="off"
                initialValues={{ emails: props.projectReportConfig.emails }} 
            >                
                <Form.Item 
                    label='Correos' 
                    name='emails'
                    rules={[
                        {
                            validator: async (_, emails: string[]) => {
                                if (emails) {
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    const invalidEmails = emails.filter(email => !emailRegex.test(email));
                                    if (invalidEmails.length > 0) {
                                        return Promise.reject(new Error('Hay correos con formato inválido'));
                                    }
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Select 
                        mode="tags" 
                        style={{ width: '100%' }} 
                        placeholder="Escribe un email y pulsa Enter"
                        tokenSeparators={[',', ' ']} 
                        notFoundContent={null} 
                    >
                        
                    </Select>
                </Form.Item>    
            </Form>
        </Modal>
    </>
  )
}

